import { FEATURES } from "@/domain/erpFeatures";

const CUSTOMER_PERMISSION_CATALOG = [
  {
    id: "customer.tenant.settings",
    label: "Tenant settings and letterhead",
    module: "Administration",
    feature: FEATURES.ADMIN,
  },
  {
    id: "customer.tenant.users",
    label: "Manage tenant users",
    module: "Administration",
    feature: FEATURES.ADMIN,
  },
  {
    id: "customer.tenant.roles",
    label: "Manage customer roles",
    module: "Administration",
    feature: FEATURES.ADMIN,
  },
  {
    id: "customer.tenant.companies",
    label: "Operating companies",
    module: "Administration",
    feature: FEATURES.ADMIN,
  },
  {
    id: "customer.scope.all_companies",
    label: "All operating companies",
    module: "Administration",
    feature: FEATURES.ADMIN,
  },
  {
    id: "customer.orders.read",
    label: "View orders",
    module: "Order to trip",
    feature: FEATURES.ORDERS,
  },
  {
    id: "customer.orders.write",
    label: "Create and edit orders",
    module: "Order to trip",
    feature: FEATURES.ORDERS,
  },
  {
    id: "customer.orders.delete",
    label: "Delete orders",
    module: "Order to trip",
    feature: FEATURES.ORDERS,
  },
  {
    id: "customer.trips.read",
    label: "View trips",
    module: "Trips",
    feature: FEATURES.TRIPS,
  },
  {
    id: "customer.trips.write",
    label: "Manage trips",
    module: "Trips",
    feature: FEATURES.TRIPS,
  },
  {
    id: "customer.pod.read",
    label: "View POD",
    module: "POD",
    feature: FEATURES.POD,
  },
  {
    id: "customer.finance.read",
    label: "View finance",
    module: "Finance",
    feature: FEATURES.FINANCE,
  },
  {
    id: "customer.finance.write",
    label: "Post receipts and billing",
    module: "Finance",
    feature: FEATURES.FINANCE,
  },
  {
    id: "customer.office.read",
    label: "View office",
    module: "Office",
    feature: FEATURES.OFFICE,
  },
  {
    id: "customer.office.write",
    label: "Manage office tasks",
    module: "Office",
    feature: FEATURES.OFFICE,
  },
  {
    id: "customer.fleet.read",
    label: "View fleet",
    module: "Fleet",
    feature: FEATURES.FLEET,
  },
  {
    id: "customer.fleet.write",
    label: "Manage fleet",
    module: "Fleet",
    feature: FEATURES.FLEET,
  },
  {
    id: "customer.workshop.read",
    label: "View workshop",
    module: "Workshop",
    feature: FEATURES.WORKSHOP,
  },
  {
    id: "customer.workshop.write",
    label: "Manage workshop",
    module: "Workshop",
    feature: FEATURES.WORKSHOP,
  },
  {
    id: "customer.insights.read",
    label: "View insights",
    module: "Insights",
    feature: FEATURES.INSIGHTS,
  },
];

const PLATFORM_PERMISSION_CATALOG = [
  { id: "platform.dashboard", label: "Platform dashboard", module: "Platform" },
  {
    id: "platform.customers.read",
    label: "View system customers",
    module: "Customers",
  },
  {
    id: "platform.customers.write",
    label: "Create and edit customers",
    module: "Customers",
  },
  {
    id: "platform.customer_modules",
    label: "Customer module switches",
    module: "Customers",
  },
  {
    id: "platform.customer_users",
    label: "Customer users",
    module: "Customers",
  },
  {
    id: "platform.customer_billing",
    label: "Customer billing",
    module: "Customers",
  },
  { id: "platform.impersonate", label: "Open customer workspace", module: "Ops" },
  { id: "platform.operators", label: "Platform operators", module: "Platform" },
  { id: "platform.roles", label: "Platform roles", module: "Platform" },
];

const PERMISSION_FEATURE_MAP = Object.fromEntries(
  CUSTOMER_PERMISSION_CATALOG.map((p) => [p.id, p.feature]),
);

export {
  CUSTOMER_PERMISSION_CATALOG,
  PERMISSION_FEATURE_MAP,
  PLATFORM_PERMISSION_CATALOG,
};
